import { BadgeCheck, CircleDot, Clock, AlertTriangle, XCircle, Star, FlaskConical, ShieldCheck } from "lucide-react";
import { label } from "@/lib/api";

export const DemoBadge = ({ className = "" }) => (
  <span data-testid="demo-badge" className={`inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 ${className}`}>
    <FlaskConical className="h-3 w-3" /> Demo
  </span>
);

export const AcceptingBadge = ({ accepting, size = "md" }) => (
  <span data-testid="accepting-status-badge"
    className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${size === "sm" ? "text-[11px] px-2 py-0.5" : "text-xs px-2.5 py-1"} ${accepting ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "bg-slate-100 text-slate-600 border border-slate-200"}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${accepting ? "bg-emerald-500 animate-pulse" : "bg-slate-400"}`} />
    {accepting ? "Accepting New Clients" : "Not Currently Accepting Clients"}
  </span>
);

const READY = {
  ready_to_work: { t: "Ready to Work", c: "bg-emerald-50 text-emerald-700 border-emerald-200", d: "bg-emerald-500" },
  credential_expiring: { t: "Credential Expiring", c: "bg-amber-50 text-amber-800 border-amber-200", d: "bg-amber-500" },
  missing_required: { t: "Missing Required Credential", c: "bg-red-50 text-red-700 border-red-200", d: "bg-red-500" },
  verification_pending: { t: "Verification Pending", c: "bg-slate-50 text-slate-700 border-slate-300", d: "bg-slate-300" },
};
export const ReadinessBadge = ({ status }) => {
  const r = READY[status] || READY.verification_pending;
  return (
    <span data-testid="readiness-badge" className={`inline-flex items-center gap-1.5 rounded-full border text-xs font-semibold px-2.5 py-1 ${r.c}`}>
      <span className={`h-2 w-2 rounded-full ${r.d}`} /> {r.t}
    </span>
  );
};

const VSTAT = {
  verified: { i: BadgeCheck, c: "text-emerald-600", t: "Verified" },
  pending: { i: Clock, c: "text-slate-500", t: "Pending review" },
  more_info_required: { i: AlertTriangle, c: "text-amber-600", t: "More info required" },
  rejected: { i: XCircle, c: "text-red-600", t: "Rejected" },
  expired: { i: XCircle, c: "text-red-600", t: "Expired" },
  not_submitted: { i: CircleDot, c: "text-slate-400", t: "Not submitted" },
};
export const VerificationStatus = ({ status, expiring }) => {
  const v = VSTAT[status] || VSTAT.not_submitted;
  const I = v.i;
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-semibold ${expiring ? "text-amber-600" : v.c}`}>
      <I className="h-3.5 w-3.5" /> {expiring ? "Expiring soon" : v.t}
    </span>
  );
};

export const VerifiedChip = ({ item }) => (
  <span className="inline-flex items-center gap-1 rounded-md bg-teal-50 text-teal-800 border border-teal-100 text-[11px] font-semibold px-2 py-0.5" data-testid="provider-verification-chip">
    <ShieldCheck className="h-3 w-3" /> {item.label}{item.is_demo && <span className="text-amber-700 font-bold">· DEMO</span>}
  </span>
);

export const Stars = ({ value = 0, count, size = 14 }) => (
  <span className="inline-flex items-center gap-1" data-testid="rating-stars">
    <Star style={{ width: size, height: size }} className={value ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
    <span className="text-sm font-semibold text-slate-800">{value ? value.toFixed(1) : "New"}</span>
    {count != null && <span className="text-xs text-slate-500">({count})</span>}
  </span>
);

const PILL = { new: "bg-cyan-50 text-cyan-800", approved: "bg-emerald-50 text-emerald-700", verified: "bg-emerald-50 text-emerald-700", hired: "bg-emerald-50 text-emerald-700",
  accepted: "bg-emerald-50 text-emerald-700", active: "bg-emerald-50 text-emerald-700", open: "bg-emerald-50 text-emerald-700",
  pending_review: "bg-amber-50 text-amber-800", pending: "bg-amber-50 text-amber-800", more_info_required: "bg-amber-50 text-amber-800", reviewing: "bg-amber-50 text-amber-800",
  rejected: "bg-red-50 text-red-700", suspended: "bg-red-50 text-red-700", declined: "bg-red-50 text-red-700", expired: "bg-red-50 text-red-700" };
export const StatusPill = ({ status }) => (
  <span data-testid={`status-pill-${status}`} className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${PILL[status] || "bg-slate-100 text-slate-700"}`}>{label(status)}</span>
);
